var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_713_28171)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 24.4927V28.0008H0V24.5055C1.62861 22.329 3.74256 20.5626 6.17375 19.3466C8.60495 18.1306 11.2863 17.4986 14.0047 17.5008C19.726 17.5008 24.808 20.2472 28 24.4927ZM18.669 10.4997C18.669 11.7374 18.1773 12.9243 17.3022 13.7995C16.427 14.6747 15.24 15.1663 14.0023 15.1663C12.7647 15.1663 11.5777 14.6747 10.7025 13.7995C9.82733 12.9243 9.33567 11.7374 9.33567 10.4997C9.33567 9.262 9.82733 8.07501 10.7025 7.19984C11.5777 6.32467 12.7647 5.83301 14.0023 5.83301C15.24 5.83301 16.427 6.32467 17.3022 7.19984C18.1773 8.07501 18.669 9.262 18.669 10.4997Z",
    fill: "#CDCDCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_713_28171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.6d0b6e2f876d80af130047d8502adee9.svg";
export { ForwardRef as ReactComponent };